import { render } from "./ProjectList.vue?vue&type=template&id=7e81d95e&scoped=true"
import script from "./ProjectList.vue?vue&type=script&lang=js"
export * from "./ProjectList.vue?vue&type=script&lang=js"

import "./ProjectList.vue?vue&type=style&index=0&id=7e81d95e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7e81d95e"

export default script